const lists = () => ({
  parentNav: 'lists',
  routes: [
    'list_dashboard',
    'list_members',
    'list_member_profile',
    'list_block_list',
    'list_block_list_member_profile',
  ],
  menuItems: [],
});

export default lists;
